
import PawSvg from "./chasingtail.gif"

import { useEffect, useState } from "react"
import { Link } from "react-router-dom"

export default function SocialGroupLinkButton({ type }) {

    const [data, setData] = useState(null);

    useEffect(() => {
        switch (type) {
            case 'map':
                setData({
                    name: "Map",
                    link: "https://socalfurs.com/events/map",
                    img: PawSvg,
                    bgc: "#f69608"
                });
        }
    }, [type])

    if (data === null) return;

    return (
        <Link to={data.link} style={{textDecoration: 'none'}}>
            <button
                style={{
                    
                    border: 'none',
                    backgroundColor: data.bgc,
                    color: 'white',
                    padding: '8px 12px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 8,
                    width: 125
                }}
            >
                <img src={data.img} style={{height: 70, width: 70}} />
                <span>{data.name}</span>
            </button>
        </Link>
    )
}
